"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const C2dTintCache_1 = require("./C2dTintCache");
class C2dTextureTintManager {
    constructor(stage) {
        this.stage = stage;
        this._usedMemory = 0;
        this._cachedNativeTextures = new Set();
    }
    destroy() {
        this.gc(true);
    }
    _addMemoryUsage(delta) {
        this._usedMemory += delta;
        this.stage.addMemoryUsage(delta);
    }
    delete(nativeTexture) {
        // Should be called when native texture is cleaned up.
        if (this._hasCache(nativeTexture)) {
            const cache = this._getCache(nativeTexture);
            const prevMemUsage = cache.memoryUsage;
            cache.clear();
            this._cachedNativeTextures.delete(nativeTexture);
            this._addMemoryUsage(cache.memoryUsage - prevMemUsage);
        }
    }
    getTintTexture(nativeTexture, color) {
        const frame = this.stage.frameCounter;
        this._cachedNativeTextures.add(nativeTexture);
        const cache = this._getCache(nativeTexture);
        const item = cache.get(color);
        item.lf = frame;
        if (item.tx) {
            if (nativeTexture.updateFrame > item.u) {
                // Native texture was updated in the mean time: renew.
                this._tintTexture(item.tx, nativeTexture, color);
            }
            return item.tx;
        }
        else {
            const before = cache.memoryUsage;
            // Find blanco tint texture.
            let target = cache.reuseTexture(frame);
            if (target) {
                target.context.clearRect(0, 0, target.w, target.h);
            }
            else {
                // Allocate new.
                target = document.createElement("canvas");
                target.w = nativeTexture.w;
                target.h = nativeTexture.h;
                target.width = nativeTexture.width;
                target.height = nativeTexture.height;
                target.context = target.getContext("2d");
            }
            this._tintTexture(target, nativeTexture, color);
            cache.set(color, target, frame);
            const after = cache.memoryUsage;
            if (after !== before) {
                this._addMemoryUsage(after - before);
            }
            return target;
        }
    }
    _tintTexture(target, source, color) {
        let col = color.toString(16);
        while (col.length < 6) {
            col = "0" + col;
        }
        target.context.fillStyle = "#" + col;
        target.context.globalCompositeOperation = "copy";
        target.context.fillRect(0, 0, source.w, source.h);
        target.context.globalCompositeOperation = "multiply";
        target.context.drawImage(source, 0, 0, source.w, source.h, 0, 0, target.w, target.h);
        // Alpha-mix the texture.
        target.context.globalCompositeOperation = "destination-in";
        target.context.drawImage(source, 0, 0, source.w, source.h, 0, 0, target.w, target.h);
    }
    _hasCache(nativeTexture) {
        return !!nativeTexture.tintCache;
    }
    _getCache(nativeTexture) {
        if (!nativeTexture.tintCache) {
            nativeTexture.tintCache = new C2dTintCache_1.C2dTintCache(nativeTexture);
        }
        return nativeTexture.tintCache;
    }
    gc(aggressive = false) {
        const frame = this.stage.frameCounter;
        let delta = 0;
        this._cachedNativeTextures.forEach((texture) => {
            const cache = this._getCache(texture);
            const before = cache.memoryUsage;
            cache.cleanup(frame);
            cache.releaseBlancoTextures();
            delta += cache.memoryUsage - before;
        });
        if (aggressive) {
            this._cachedNativeTextures.clear();
        }
        if (delta) {
            this._addMemoryUsage(delta);
        }
    }
}
exports.C2dTextureTintManager = C2dTextureTintManager;
//# sourceMappingURL=C2dTextureTintManager.js.map